<template>
  <SysDialog v-model="dialog_ativo" :largura="filtros.apenas_produto_selecionado ? 600 : 800">
    <template #ativador>
      <v-btn @click="openDialog" small color="primary">
        <v-icon :size="20" color="white" v-text="'mdi-filter'" class="mr-2" />
        Filtros
      </v-btn>
    </template>

    <template #titulo.texto>
      <div>
        <p class="ma-0">Listagem de produtos a ser analisada</p>
        <p class="ma-0 mt-n2 font-12 font-weight-regular text-gray-1000">
          Combine os filtros para visualização dos produtos
        </p>
      </div>
    </template>

    <v-radio-group v-if="!props.forcar_busca_pelos_filtros_combinados" v-model="filtros.apenas_produto_selecionado">
      <v-radio :value="true">
        <template #label>
          <span class="ml-1">Buscar apenas o produto selecionado</span>
        </template>
      </v-radio>

      <v-radio :value="false">
        <template #label>
          <span class="ml-1">Buscar produtos através de filtros combinados</span>
        </template>
      </v-radio>
    </v-radio-group>

    <DivisorComLegenda v-if="!filtros.apenas_produto_selecionado" legenda="Filtros" class="mb-5" />

    <BlocoFiltrosPrincipais
      v-show="!filtros.apenas_produto_selecionado"
      :filtros="filtros"
      ocultar_filtro_filiais
    />

    <template #actions>
      <v-btn text color="primary" @click="filtrar">
        FILTRAR
      </v-btn>
    </template>
  </SysDialog>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import DivisorComLegenda from '@/components/utils/DivisorComLegenda.vue';
import BlocoFiltrosPrincipais from '@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais.vue';

const props = defineProps({
  forcar_busca_pelos_filtros_combinados: Boolean,
});

const emit = defineEmits(['update:filtros']);

const dialog_ativo = ref(false);

const filtros = ref({
  apenas_produto_selecionado: true,
  grupos: [],
  segmentos: [],
  secoes: [],
  categorias: [],
  linhas: [],
  compradores: [],
  fornecedores: [],
});

onMounted(() => openDialog());

function openDialog() {
  dialog_ativo.value = true;

  if (props.forcar_busca_pelos_filtros_combinados) {
    filtros.value.apenas_produto_selecionado = false;
  }
}

function filtrar() {
  dialog_ativo.value = false;

  const ev = {
    filtros: {...filtros.value},
  };

  emit('update:filtros', ev);
}
</script>
